import { type CartType, CartTypes } from './model';
import { useCartStore } from './cartStore';
import useModernCheckout from '~/utils/shop/useModernCheckout';
import BuildMagentoCheckoutUrl from '~/utils/shop/buildMagentoCheckoutUrl';

const hasCheckoutQueryParameter = () => {
  const route = useRoute();
  return (
    'feature' in route.query &&
    ensureArray(route.query.feature).includes('new-checkout')
  );
};

/**
 * Creates a cart link using the given cart type.
 * This composable uses {@link useCartStore} and can
 * only be used in a setup function, plugin, or route middleware.
 *
 * @param type The cart type to use.
 */
export function useCartLink(type: CartType): string | undefined {
  const { $activeLocale, $globalPageSettings } = useNuxtApp();
  const cartStore = useCartStore();
  const cart = cartStore.carts[type];
  if (!cart) {
    return;
  }

  const cartPageSlug = (() => {
    if (type === CartTypes.CART || type === CartTypes.CUSTOMER_CART) {
      return $globalPageSettings.value?.shopConfig?.cartPage?.slug;
    }
    return $globalPageSettings.value?.shopConfig?.requestCartPage?.slug;
  })();

  if (cartPageSlug && (hasCheckoutQueryParameter() || useModernCheckout())) {
    return `/${$activeLocale.value.webapp}/${cartPageSlug}`;
  }

  return BuildMagentoCheckoutUrl(type);
}
